export enum UserRole {
  USER_ADMIN = "USER_ADMIN",
  EXPERT = "EXPERT",
}

export interface User {
  id: number;
  authUserId: number;
  firstName: string;
  lastName: string;
  email: string;
  dateCreated: Date;
  dateLastLoginLinkSent: Date;
  role: UserRole;
  enabled: boolean;
}

export type UserOrderColumn = "firstName" | "lastName" | "email" | "dateCreated";
export type UserOrderDirection = "asc" | "desc";

export interface UserPaginationParams {
  orderBy: UserOrderColumn;
  orderDirection: UserOrderDirection;
  limit: number;
  offset: number;
}

export interface UserPagination {
  totalCount: number;
  offset: number;
  limit: number;
  data: User[];
}
